<div
	class="flex bg-light-grey justify-between items-center border-b-[1px] border-solid border-b-secondry-color-Gray fixed z-10 xl:w-[89%] mediumTab:w-[85%] w-full"
>
	<div class="lg:my-[16px] my-[10px] inline-flex items-start">
		<a
			class="items-center font-Poppins text-dark rounded-lg text-center cursor-pointer text-dark-grey mt-3 w-[24px] h-[24px] ltr:ms-2 rtl:mr-2"
			(click)="toggleNav.emit()"
		>
			<mat-icon
				fontSet="material-icons-outlined"
				class="mx-auto text-bold bg-dark text-[18px] mb-[3px] mediumTab:hidden block"
			>
				menu</mat-icon
			>
		</a>
		<img
			*ngIf="breadCrumb.length > 0"
			(click)="goToBack()"
			class="ltr:lg:ml-24px ltr:ml-[8px] rtl:mr[8px] rtl:lg:mr-24px ltr:mr-2 rtl:ml-2 rtl:rotate-180 cursor-pointer md:mt-0 mt-1 md:w-[25px] w-[17px]"
			src="assets/images/arrow-left.svg"
			alt="icon"
		/>
		<div [ngClass]="this.breadCrumb.length == 1 ? 'mx-[6px]' : ''">
			<h2
				class="flex md:text-font-24 text-[13px] leading-[26px] ltr:font-DIN-Bold ltr:font-bold rtl:font-Arabic-regular rtl:font-semibold my-0 text-dark-grey whitespace-nowrap"
			>
				{{ title | translate }}
			</h2>
			<nav
				class="flex lg:mt-2 mt-0.5"
				aria-label="Breadcrumb"
				*ngIf="breadCrumb.length > 1"
			>
				<ol class="lg:inline-flex py-0 my-0 items-start space-x-1 md:space-x-1">
					<ng-container *ngFor="let path of breadCrumb; let i = index">
						<li *ngIf="i !== breadCrumb.length - 1">
							<div class="flex items-start">
								<a
									(click)="onclickLink(i, path)"
									class="ml-1 lg:text-[14px] text-[10px] text-medium-gray cursor-pointer"
									>{{ 'BREADCRUMB.' + path[0].toUpperCase() | translate }}</a
								>
								<svg
									aria-hidden="true"
									class="md:w-6 w-4 h-6 text-medium-gray"
									fill="currentColor"
									viewBox="0 0 20 20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
										clip-rule="evenodd"
									></path>
								</svg>
							</div>
						</li>
					</ng-container>
					<li>
						<div class="flex items-center">
							<span
								class="ml-1 lg:text-[14px] text-[10px] font-medium text-salon"
								>{{
									'BREADCRUMB.' +
										breadCrumb[breadCrumb.length - 1][0].toUpperCase()
										| translate
								}}</span
							>
						</div>
					</li>
				</ol>
			</nav>
		</div>
	</div>
	<div
		class="flex items-center ltr:lg:mr-[44px] ltr:mr-[10px] rtl:lg:ml-[44px] rtl:ml-[10px] text-dark-grey"
	>
		<app-notifications-dropdown></app-notifications-dropdown>

		<app-language class="text-center" [isHeader]="true"></app-language>
		<div
			class="h-[22px] border-r-[1px] border-medium-gray mx-[10px] lg:mx-[20px] rtl:ml-5"
		></div>
		<div class="flex items-center relative">
			<div class="w-[46px] h-[46px] cursor-pointer">
				<img class="rounded-full" [src]="profileImageUrl" alt="" />
			</div>
			<button class="ml-[6px] bg-[#F5F5F5] md:block hidden">
				<button
					mat-button
					class="rtl:p-0 p-0 h-[30px] flex flex-row-reverse"
					[matMenuTriggerFor]="menu"
				>
					<h3
						class="inline-block m-0 mr-[14px] text-font-14 leading-[22px] text-dark-grey"
					>
						{{ fullName }}
					</h3>
					<mat-icon class="text-dark-grey">keyboard_arrow_down</mat-icon>
				</button>

				<h4
					class="text-sm text-medium-gray rtl:pr-5 leading-[16px] font-[12px] text-start"
				>
					Owner
				</h4>
			</button>
			<mat-menu
				#menu="matMenu"
				class="w-full matMenuItem headerProfileDropdown"
				xPosition="after"
			>
				<button
					(click)="viewProfile()"
					mat-menu-item
					class="flex items-center justify-between"
				>
					<a class="m-0">Profile</a>
					<img src="assets/images/navbar_rightarrow.svg" alt="" />
				</button>
				<div class="h-[8px] w-full bg-[#D9DBE9]"></div>
				<button
					(click)="openDialog()"
					mat-menu-item
					class="flex items-center justify-between"
				>
					<a class="m-0">signOut</a>
					<img src="assets/images/navbar_logout.svg" alt="" />
				</button>
			</mat-menu>
		</div>
	</div>
</div>
